
import { connect } from 'react-redux';
import React, {Fragment, useState} from 'react'
import useToggle from 'react-use-toggle';

import {transformObjectToArray} from '../../util/dynamicSort'
import {ALL_CLINICS, adminFilterOptions, filterOptions, matchesClinic} from '../../util/clinics'
import * as actions from '../../store/actions'
import AdminAddContact from '../AdminAddContact'
import AdminAddContactCategory from '../AdminAddContactCategory/AdminAddContactCategory';
import Button from '../Button'

import ContentWrapper from '../ContentWrapper';
import {Input} from '../Form';
import MobileHeader from '../MobileHeader'
import Modal from '../Modal';
import PageHeader from '../PageHeader';
import List from '../List';
import ContactListCategory from '../ContactListCategory'
import ContactListItem from '../ContactListItem'

import styles from './ContactList.module.css';

const AdminTools = ({admin,toggleAdmin,toggleAdd,toggleAddCategory}) => {
  return (
    <div>
      
      {admin ? <Fragment>  
          <ul className={styles.AdminButtons}>
            <li><Button fontSize='0.8rem' onClick={toggleAdmin}>Close Admin Edit</Button></li>
            <li><Button fontSize='0.8rem' onClick={toggleAddCategory} >Add Category</Button> </li>
            <li><Button fontSize='0.8rem' onClick={toggleAdd} >Add Contact</Button></li>
          </ul>
        </Fragment> 
        : 
        <ul className={styles.AdminButtons}><li><Button fontSize='0.8rem' onClick={toggleAdmin}>Admin Edit</Button></li></ul>}
    </div>
  )
}

const ContactList = props => {
  const [addModal, toggleAdd] = useToggle(false);
  const [addCategoryModal, toggleAddCategory] = useToggle(false);
  const [admin, toggleAdmin] = useToggle(false);
  const [clinic, setClinic] = useState(ALL_CLINICS);

  const {
    categoryOrder = [],
    contacts,
    verified
  } = props

  // The undefined filter is a cleanup tool for admins, so it is only offered to them.
  const clinicSelectOptions = verified === 'admin' ? adminFilterOptions : filterOptions

  const uncategorizedContacts = contacts ? transformObjectToArray(contacts).filter(contact => !contact.categoryId && matchesClinic(contact, clinic)) : false

  return (
    <ContentWrapper>
      <MobileHeader>Contacts List</MobileHeader>
      
      <div className={styles.ContactList}>
        <PageHeader title="Contacts List">
          <Input
            name="clinicFilter"
            label="Clinic"
            elementType="select"
            elementConfig={{options: clinicSelectOptions}}
            value={clinic}
            changed={event => setClinic(event.target.value)}
            inputWrapperStyles={styles.ClinicFilterInputWrapper}
            labelStyles={styles.ClinicFilterLabel}
            inputInlineStyle={{maxWidth: '12rem'}} />
          {(verified === 'admin') ? <AdminTools admin={admin} toggleAdmin={toggleAdmin} toggleAddCategory={toggleAddCategory} toggleAdd={toggleAdd} /> : null }
        </PageHeader>

        <div className={styles.Body}>
          {(categoryOrder.length > 0) ? categoryOrder.map(categoryId => <ContactListCategory key={categoryId} categoryId={categoryId} admin={admin} clinic={clinic} />) : null }
          {(uncategorizedContacts && uncategorizedContacts.length > 0) ? 
            <Fragment>
              <h3>Other</h3>
              <List className={styles.List}>
                {uncategorizedContacts.map( contact => <ContactListItem key={contact.id} id={contact.id} admin={admin} /> )}
              </List>
            </Fragment>
            :null
          }
        </div>
        
        {addModal ? <Modal maxWidth='630px' backdropCloseHandler={toggleAdd}><AdminAddContact submitCallback={toggleAdd} /></Modal>: null}
        {addCategoryModal ? <Modal maxWidth='500px' backdropCloseHandler={toggleAddCategory}><AdminAddContactCategory submitCallback={toggleAddCategory} /></Modal>: null}
      </div>
    </ContentWrapper>
  )
}

const mapStateToProps = ({contacts, auth}) => {
  return {
    categoryOrder: contacts.categoryOrder,
    contacts: contacts.contacts,
    verified: auth.verified
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setContactCategoryOrder: payload => dispatch(actions.setContactCategoryOrder(payload))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactList)